import React from "react";

import Typography from "@components/shared/Typography";

import { getStaticAssetURL } from "@lib/getStaticAssetURL";
import { useTranslation } from "@lib/i18n";

import { DEFAULT_PRECONFIGURATION_ID } from "@shared/constants";
import { getCarImagePath } from "@shared/v2/lib/getCarImagePath";

const NoOfferAvailable = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center gap-8 bg-primaryLight px-8 py-16 lg:flex-row lg:p-20 min-h-[calc(100dvh-15.75rem)]">
      <div className="flex flex-col justify-center gap-8 uppercase lg:justify-start lg:p-8">
        <h1 className="text-4xl text-primaryDark font-bold text-center text-balance uppercase">
          {t("homepage.noOffer.title")}
        </h1>
        <Typography className="text-center text-balance">
          {t("homepage.noOffer.text")}
        </Typography>
      </div>
      <img
        alt="AMI"
        className="w-70 sm:w-80 lg:w-auto max-w-100"
        src={getStaticAssetURL(getCarImagePath(DEFAULT_PRECONFIGURATION_ID))}
        title="AMI"
      />
    </div>
  );
};

NoOfferAvailable.propTypes = {};

export default NoOfferAvailable;
